import tuiGrid from 'tui-grid';
import moment from 'moment';
import { ORIGIN_FORMAT } from './index';

export namespace TUI_FORMAT {
    export const NumberFormat = (params: number | string ): string => {
        return ORIGIN_FORMAT.NumberFormatOrigin(params);
    };

    export const MoneyFormat = (cellValue: string, rowAttrs: tuiGrid.IRow, column: tuiGrid.IColumnInfoOptions): string => {
        const num = Number.parseInt(cellValue);
        if (Number.isNaN(num)) {
            return '';
        }
        return ORIGIN_FORMAT.NumberFormatOrigin(num) + ' 원';
    }
    export const SummaryFormat = (params: tuiGrid.IValueMap, property: string, unit: string): string=> {
        switch (property.toLowerCase()) {
            case 'sum': return '<strong>' + ORIGIN_FORMAT.NumberFormatOrigin(params.sum) + ' ' + unit + '</strong>'; 
            case 'avg': return '<strong>' + ORIGIN_FORMAT.NumberFormatOrigin(params.avg) + ' ' + unit + '</strong>'; 
            case 'max': return '<strong>' + ORIGIN_FORMAT.NumberFormatOrigin(params.max) + ' ' + unit + '</strong>'; 
            case 'min': return '<strong>' + ORIGIN_FORMAT.NumberFormatOrigin(params.min) + ' ' + unit + '</strong>'; 
        }
        return '';
    }

    const inRowDatePrefix: string = `<span class="tuiGridInRowDate"><i class="el-icon-date"></i> `;
    const inRowDatePostfix: string = `</span>`;

    const inRowDateTagPrefix: string = `<span class="tuiGridInRowDateTag"><i class="el-icon-date"></i> `;
    const inRowDateTagPostfix: string = `</span>`;

    export const InRowDateRangeTagFormat = (date: Date[], format: string, middle: string, before: string = '', after: string = ''): string => {
        return inRowDateTagPrefix + before + moment(date[0]).format(format) + middle + moment(date[1]).format(format) + after + inRowDateTagPostfix;
    }
    export const InRowDateTagFormat = (date: Date, format: string,  before: string = '', after: string = ''): string => {
        return inRowDateTagPrefix + before + moment(date).format(format) + after + inRowDateTagPostfix;
    }

    export const InRowDateFormat  = (date: Date, format: string,  before: string = '', after: string = ''): string => {
        return inRowDatePrefix + before + moment(date).format(format) + after + inRowDatePostfix;
    }
}